import api from "../client.ts";

export type PromotionType = {
  id: number;
  eleve_id: number;
  classe_id: number;
  annee_scolaire_id: number;
  status: number;
  created_at: string;
  updated_at: string | null;
};
export type SchoolType = {
  id: number;
  designation: string;
  code: string;
  telephone: string;
  logo_path: string | null;
  status: number;
  created_at: string;
  updated_at?: string | null;
};

export type ClasseType = {
  id: number;
  designation: string;
  code: string;
  status: number;
  created_at: string; // ISO timestamp string
  updated_at: string; // ISO timestamp string
};

export type SchoolYearType = {
  id: number;
  designation: string; // e.g., "2024-2025"
  date_debut?: string;
  date_fin?: string;
  selected?: boolean;
  status?: number;
  created_at?: string; // ISO timestamp string
  updated_at?: string; // ISO timestamp string
};

export type MontantPerClasseTtype = {
  id: number;
  montant: number;
  classe_id: number;
  annee_scolaire_id: number;
  status: number;
  created_at: string;
  updated_at: string;
};

export type FunctionType = {
  id: number;
  designation: string;
  code: string;
  status: number;
  created_at: string; // ISO date-time string
  updated_at: string | null;
};
export type DomainType = {
  id: number;
  designation: string;
  code: string;
  status: number;
  created_at: string; // ISO date-time string
  updated_at: string | null;
};
export type GradeType = {
  id: number;
  designation: string;
  code: string;
  status: number;
  created_at: string; // ISO date-time string
  updated_at: string | null;
};

type MotifFraisType = {
  id: number;
  designation: string;
  status: number;
  created_at: string; // ou Date si tu parses les dates
  updated_at: string | null; // peut être null donc on le précise
};

type TerminalType = {
  id: number;
  uid: string;
  designation: string;
  status: number;
  created_at: string; // ISO datetime string
  updated_at: string; // ISO datetime string
};

export const schoolController = {
  getAll: async (): Promise<{ size: number; data: SchoolType[] }> => {
    const { data } = await api.get("/ecole/readAll");
    return data;
  },
  create: async (newRecord: any) => {
    const { data } = await api.post("/ecole/create", newRecord);
    return data;
  },
  update: async (id: any, newRecord: any) => {
    const { data } = await api.put(`/ecole/update?id=${id}`, newRecord);
    return data;
  },

  uploadLogo: async (id: any, newRecord: any) => {
    const { data } = await api.post("/ecole/uploadLogo?id=" + id, newRecord);
    return data;
  },
};
export const schoolYearController = {
  create: async (newRecord: any) => {
    const { data } = await api.post("/annee_scolaire/create", newRecord);
    return data;
  },
  update: async (id: any, newRecord: any) => {
    const { data } = await api.put(
      `/annee_scolaire/update?id=${id}`,
      newRecord,
    );
    return data;
  },
  delete: async (id: any) => {
    const { data } = await api.delete(`/annee_scolaire/delete?id=${id}`);
    return data;
  },
  activate: async (id: any) => {
    const { data } = await api.get(`/annee_scolaire/active?id=${id}`);
    return data;
  },
  getAll: async (): Promise<{ size: number; data: SchoolYearType[] }> => {
    const { data } = await api.get("/annee_scolaire/readAll");
    return data;
  },
  getActive: async (): Promise<{ size: number; data: SchoolYearType[] }> => {
    const { data } = await api.get("/annee_scolaire/readActive");
    return data;
  },
  selectYear: async (id: number) => {
    const { data } = await api.get("/annee_scolaire/selected?id=" + id);
    return data;
  },
};
export const promotionController = {
  getAll: async (): Promise<{ size: number; data: PromotionType[] }> => {
    const { data } = await api.get("/promotion/readAll");
    return data;
  },
  create: async (newRecord: any) => {
    const { data } = await api.post("/promotion/create", newRecord);
    return data;
  },
};
export const classeController = {
  getAll: async (): Promise<{ size: number; data: ClasseType[] }> => {
    const { data } = await api.get("/classe/readAll");
    return data;
  },

  create: async (newRecord: any) => {
    const { data } = await api.post("/classe/create", newRecord);
    return data;
  },

  update: async (id: any, newRecord: any) => {
    const { data } = await api.put(`/classe/update?id=${id}`, newRecord);
    return data;
  },
  activate: async (id: any) => {
    const { data } = await api.get(`/classe/active?id=${id}`);
    return data;
  },

  desactivate: async (id: any) => {
    const { data } = await api.get(`/classe/desactive?id=${id}`);
    return data;
  },

  delete: async (id: any) => {
    const { data } = await api.delete(`/classe/delete?id=${id}`);
    return data;
  },

  getAllActive: async (): Promise<{ size: number; data: ClasseType[] }> => {
    const { data } = await api.get("/classe/readActive");
    return data;
  },
};
export const domainController = {
  getAll: async (): Promise<{ size: number; data: DomainType[] }> => {
    const { data } = await api.get("/domaine/readAll");
    return data;
  },

  create: async (newRecord: any) => {
    const { data } = await api.post("/domaine/create", newRecord);
    return data;
  },

  update: async (id: any, newRecord: any) => {
    const { data } = await api.put(`/domaine/update?id=${id}`, newRecord);
    return data;
  },
  activate: async (id: any) => {
    const { data } = await api.get(`/domaine/active?id=${id}`);
    return data;
  },

  desactivate: async (id: any) => {
    const { data } = await api.get(`/domaine/desactive?id=${id}`);
    return data;
  },

  delete: async (id: any) => {
    const { data } = await api.delete(`/domaine/delete?id=${id}`);
    return data;
  },
};
export const functionController = {
  getAll: async (): Promise<{ size: number; data: FunctionType[] }> => {
    const { data } = await api.get("/fonction/readAll");
    return data;
  },

  create: async (newRecord: any) => {
    const { data } = await api.post("/fonction/create", newRecord);
    return data;
  },

  update: async (id: any, newRecord: any) => {
    const { data } = await api.put(`/fonction/update?id=${id}`, newRecord);
    return data;
  },
  activate: async (id: any) => {
    const { data } = await api.get(`/fonction/active?id=${id}`);
    return data;
  },

  desactivate: async (id: any) => {
    const { data } = await api.get(`/fonction/desactive?id=${id}`);
    return data;
  },

  delete: async (id: any) => {
    const { data } = await api.delete(`/fonction/delete?id=${id}`);
    return data;
  },
};
export const gradeController = {
  getAll: async (): Promise<{ size: number; data: GradeType[] }> => {
    const { data } = await api.get("/grade/readAll");
    return data;
  },

  create: async (newRecord: any) => {
    const { data } = await api.post("/grade/create", newRecord);
    return data;
  },

  update: async (id: any, newRecord: any) => {
    const { data } = await api.put(`/grade/update?id=${id}`, newRecord);
    return data;
  },
  activate: async (id: any) => {
    const { data } = await api.get(`/grade/active?id=${id}`);
    return data;
  },

  desactivate: async (id: any) => {
    const { data } = await api.get(`/grade/desactive?id=${id}`);
    return data;
  },

  delete: async (id: any) => {
    const { data } = await api.delete(`/grade/delete?id=${id}`);
    return data;
  },
};
export const montantController = {
  getAll: async (): Promise<{
    size: number;
    data: MontantPerClasseTtype[];
  }> => {
    const { data } = await api.get("/montant/readAll");
    return data;
  },
  update: async (id: any, newRecord: any) => {
    const { data } = await api.put(`/montant/update?id=${id}`, newRecord);
    return data;
  },
  delete: async (id: any) => {
    const { data } = await api.delete(`/montant/delete?id=${id}`);
    return data;
  },
  create: async (newRecord: any) => {
    const { data } = await api.post("/montant/create", newRecord);
    return data;
  },
};

export const terminalController = {
  getAll: async (): Promise<{ size: number; data: TerminalType[] }> => {
    const { data } = await api.get("/terminal/readAll");
    return data;
  },
  update: async (id: any, newRecord: any) => {
    const { data } = await api.put(`/terminal/update?id=${id}`, newRecord);
    return data;
  },
  activate: async (id: any) => {
    const { data } = await api.get(`/terminal/active?id=${id}`);
    return data;
  },
  desactivate: async (id: any) => {
    const { data } = await api.get(`/terminal/desactive?id=${id}`);
    return data;
  },
  delete: async (id: any) => {
    const { data } = await api.delete(`/terminal/delete?id=${id}`);
    return data;
  },
  create: async (newRecord: any) => {
    const { data } = await api.post("/terminal/create", newRecord);
    return data;
  },
};
export const motifPaiementController = {
  getAll: async (): Promise<{ size: number; data: MotifFraisType[] }> => {
    const { data } = await api.get("/motif_paiement/readAll");
    return data;
  },
};
